import React from "react";
import { useState } from "react";
import bellIcon from "../../assets/bell_icon.svg";
import settingIcon from "../../assets/setting_icon.svg";
import { BiArrowBack } from "react-icons/bi";
import { useNavigate } from "react-router-dom";
import { FiMenu} from "react-icons/fi";
import { Settings } from "../../pages/settings/Settings";
import { getRole } from "../../utils/GetRole";
import { UserSidebar } from "../sidebar/mobile_sidebar/UserSidebar";
import { AdminSidebar } from "../sidebar/mobile_sidebar/AdminSidebar";
import { ArtistSidebar } from "../sidebar/mobile_sidebar/ArtistSidebar";

export const Header = ({ title, name, showBack }) => {
  const navigate = useNavigate();
  const [isOpen, setOpenMenu] = useState(false);
  const [settingOpen, setSettingOpen] = useState(false);

  const authUser = JSON.parse(localStorage.getItem("authUser"));
  const role = getRole();

  const handleToggleMenu = () => {
    setOpenMenu(!isOpen);
  };

  return (
    <>
      <div className="w-full  h-12 flex items-center justify-between md:hidden ">
        {/* Left Side */}
        <div className="flex items-center">
          <button onClick={handleToggleMenu}>
            <FiMenu size={26} className="text-primary" />
          </button>
        </div>

        {/* Right Side */}
        <div className="flex items-center gap-4">
          <button
            onClick={() => navigate("/artist/notifications")}
            className="border border-border_color p-1 rounded-lg"
          >
            <img src={bellIcon} alt="Notifications" />
          </button>
          <button
            onClick={() => setSettingOpen(true)}
            className="border border-border_color p-1 rounded-lg"
          >
            <img src={settingIcon} alt="Settings" />
          </button>
        </div>

        {role === "user" ? (
          <UserSidebar isOpen={isOpen} setOpenMenu={setOpenMenu} />
        ) : role === "admin" ? (
          <AdminSidebar isOpen={isOpen} setOpenMenu={setOpenMenu} />
        ) : role === "artist" ? (
          <ArtistSidebar isOpen={isOpen} setOpenMenu={setOpenMenu} />
        ) : null}
        <Settings
          settingOpen={settingOpen}
          setSetting={() => setSettingOpen(false)}
        />
      </div>

      <div className="w-full  h-[67px] items-center justify-between hidden md:flex mt-5">
        {/* Left Side */}
        <div className="flex items-center gap-3">
          {/* Back Button */}
          {showBack && (
            <div
              className="w-7 h-7 bg-transparent rounded-lg border border-border_color flex items-center justify-center cursor-pointer"
              onClick={() => navigate(-1)}
            >
              <BiArrowBack className="text-2xl" />
            </div>
          )}

          {title ? (
            <span className="text-black font-grotesk font-bold text-lg sm:text-[26px]">
              {title}
            </span>
          ) : (
            <span className="text-black font-grotesk font-bold text-sm sm:text-[26px]">
              Welcome,
              <span className="text-[22px] font-normal font-grotesk text-black opacity-30">
                {" "}
                {authUser?.user?.name}{" "}
              </span>
            </span>
          )}
        </div>

        {/* Right Side */}
        <div className="flex items-center gap-4">
          <button
            onClick={() => navigate(`/${role}/notifications`)}
            className="border border-border_color p-1 rounded-lg"
          >
            <img src={bellIcon} alt="Notifications" />
          </button>
          <button
            onClick={() => setSettingOpen(true)}
            className="border border-border_color p-1 rounded-lg"
          >
            <img src={settingIcon} alt="Settings" />
          </button>
        </div>
        <Settings
          settingOpen={settingOpen}
          setSetting={() => setSettingOpen(false)}
        />
      </div>
    </>
  );
};
